import React, { useEffect, useState } from "react";

import "./styles/index.scss";
import { connect } from "react-redux";
import { clickToLinkHandler } from "../../../helpers/utils";
import { getCompanyByOrgId } from "../../../api/company/company";
import {
  configureAuthHeader,
  configureBaseUrl,
} from "../../../api/axiosConfig";
import * as api from "../../../api/generated-api";
import DealInformationForm from "./dealInformationForm";
import { createDeal } from "../../../api/deals/deals";
import { emptyDealSeriesProperties } from "../DealInformationPage/DealInformationPage";
import { DealsPageLayout } from "../dealsPageLayout/DealsPageLayout";

type CreateDealsProps = {
  token: string;
  orgId: number;
  dealType: "financing";
  dealCreated: boolean;
};

const CreateDealPage = (props: CreateDealsProps) => {
  const { token, orgId } = props;

  configureBaseUrl();
  configureAuthHeader(token);

  const [company, setCompany] = useState<api.Company>(null);
  const [deal, setDeal] = useState<api.DealCreate>({
    seriesOfPreferredStockSold: "Series Seed",
    totalRoundSize: undefined,
    valuation: undefined,
    series: undefined,
  });
  const [dealSeries, setDealSeries] = useState<api.DealSeries[]>([
    {
      ...emptyDealSeriesProperties,
      name: "Series Seed",
      pricePerShare: undefined,
      isPrimary: true,
    },
  ]);

  const saveNewDeal = (deal: api.DealCreate) => {
    createDeal(
      orgId,
      {
        ...deal,
        series: dealSeries,
      },
      (savedDeal) => {
        clickToLinkHandler(
          "/" +
            savedDeal.organizationId +
            "/deals/" +
            savedDeal.id +
            "/edit/company-information"
        );
      }
    );
  };

  useEffect(() => {
    if (orgId) {
      getCompanyByOrgId(orgId, (company) => {
        setCompany(company);
      });
    }
  }, [orgId]);

  const canCreateDeal = () => {
    return (
      deal.seriesOfPreferredStockSold &&
      dealSeries[0].pricePerShare > 0 &&
      deal.totalRoundSize &&
      deal.valuation
    );
  };

  return (
    <>
      {company && (
        <DealsPageLayout
          title={`${company.name} - Preferred Stock Financing`}
          actionButtons={[
            {
              primary: true,
              disabled: !canCreateDeal(),
              dataTestId: "deal-information-save-button",
              label: "save",
              onClick: () => {
                if (canCreateDeal()) {
                  saveNewDeal(deal);
                }
              },
            },
          ]}
        >
          <DealInformationForm
            deal={deal}
            dealSeries={dealSeries}
            dealLegalEntityInvestments={[]}
            onDealChange={(updatedDeal) => {
              setDeal({ ...deal, ...updatedDeal });
            }}
            onDealSeriesChange={(updatedDealSeries) =>
              setDealSeries(updatedDealSeries)
            }
          />
        </DealsPageLayout>
      )}
    </>
  );
};

const mapStateToProps = (state, props) => {
  const {
    match: {
      params: { orgId, description: dealType },
    },
  } = props;
  const { token, user } = state.auth;

  return {
    token,
    orgId,
    dealType,
    user,
  };
};

export default connect(mapStateToProps)(CreateDealPage);
